import React from 'react';

export const ScrollToTopContext = React.createContext({ scrollToTop: () => {} });

export const useScrollToTop = () => React.useContext(ScrollToTopContext);
